import React, { Component } from 'react';
import { baseUrl } from '../../utils';
import BentoLoader from './BentoLoader';

export default class LoadingScreen extends Component {
    render() {
        return (
            <div>
                <div className="container">
                    <div id="Iframe-data" className="postLoader">
                        <div className="d-flex align-items-center justify-content-center h-100 w-100">
                            {this.props.switcher ?
                                <>
                                    <div className="d-block text-center">
                                        <img className="img-fluid" src={baseUrl(`logos/switcher_loader.gif`)} alt="" width="200" height="46" />
                                        <p className="mb-0 mt-10 mb-0 mt-10 font-size-h3">Redirecting you to <a title="Social Walls" href="https://socialwalls.com/" target='_blank'>Social Walls by Taggbox</a>, built for interactive social media displays and experiences.
                                        </p>
                                    </div>
                                </>
                                :
                                <BentoLoader size={50} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
